import styled from 'styled-components';
import { breakpoint } from 'styles/globals';

export const ZoomButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  margin-bottom: 10px;
`;

export const FullScreenButtonsContainer = styled.div`
  width: 270px;
  left: calc(50vw - 135px);
  position: fixed;
  top: 0;
  z-index: 99999;
`;

export const PDFContainer = styled.div`
  margin-bottom: 48px;
  height: 248px;
  
  @media (${breakpoint.mdMin}) {
    height: 400px;
    margin-bottom: 68px;
  }
`;
